<div class="setting-div" [class.isAlongTopSide]="data.index === 0">
  <ul>
    <ng-content></ng-content>
    
    <!-- 增加區塊 -->
    <li *ngIf="canAddSection">
      <a href="javascript:void(0)" class="edit-icon" (click)="addSection()"> <i class="fa fa-clone fa-lg"></i>
        <div class="tooltip">增加區塊</div>
      </a>
    </li>
    <!-- /增加區塊 -->
    
    <!-- 刪除區塊 -->
    <li *ngIf="canDelSection">
      <a href="javascript:void(0)" class="edit-icon" (click)="rmSection()"> <i class="fa fa-trash fa-lg"></i>
        <div class="tooltip">刪除區塊</div>
      </a>
    </li>
    <!-- /刪除區塊 -->
    
    <!-- 區塊顯示 -->
    <li *ngIf="canToggleVision">
      <a href="javascript:void(0)" class="edit-icon" (click)="toggleEnable()"> <i class="fa fa-eye fa-lg" [class.fa-eye]="data.enable" [class.fa-eye-slash]="!data.enable"></i>
        <div class="tooltip">開啟/隱藏</div>
      </a>
    </li>
    <!-- /區塊顯示 -->
    
    <li *ngIf="canToggleWow">
      <a href="javascript:void(0)" class="edit-icon toggleWow" (click)="toggleWow()">
      <i class="fa fa-ellipsis-h"></i>
        <div class="tooltip">設定動畫</div>
      </a>
      <div class="wowSetting" *ngIf="showWowPanel">
        <app-wow-control-panel [(ngModel)]="data.wowSetting" name="wowSet_{{data.uuid}}"></app-wow-control-panel>
      </div>
    </li>

    <!-- 區塊上下調整按鈕 -->
    <li style="vertical-align: middle;" *ngIf="canMoveSection">
      <div class="caretbox">
        <button class="btn btn-light caretup" title="上移" (click)="up()"><i class="fa fa-lg fa-caret-up"></i></button>
        <button class="btn btn-light caretdown" title="下移" (click)="down()"><i class="fa fa-lg fa-caret-down"></i></button>
      </div>
    </li>
    <!-- /.區塊上下調整按鈕 -->
  </ul>
</div>
